import { useGate, useStore, useStoreMap } from 'effector-react'
import { aggregatorDriverModel } from '~/entities/common/Driver/Aggregator'
import { YandexForm } from '~/entities/common/Driver/Aggregator/ui/Form/YandexForm'
import { usePermissions } from '~/entities/common/viewer'
import {
  Gate,
  formSubmitted,
  aggregatorDriverUpdateFx,
  $aggregatorDriver,
} from './model'

type EditYandexAggregatorProps = {
  aggregatorId: string
}
export function EditYandexAggregator({
  aggregatorId,
}: EditYandexAggregatorProps) {
  useGate(Gate, { aggregatorId })
  const { canDriverUpdateAggregator } = usePermissions()

  const isSubmitting = useStore(aggregatorDriverUpdateFx.pending)
  const isLoading = useStore(aggregatorDriverModel.requestFx.pending)

  const accountId = useStoreMap($aggregatorDriver, (aggregatorDriver) =>
    aggregatorDriver?.getAggregatorAccount()?.getApiId(),
  )

  const defaultValues = useStoreMap($aggregatorDriver, (aggregatorDriver) => {
    const yandexWorkRule = aggregatorDriver?.getYandexWorkRule()
    const aggregatorOccupation = aggregatorDriver?.getAggregatorOccupation()
    return {
      ...aggregatorDriver?.getAttributes(),
      yandexWorkRule: yandexWorkRule?.getTitle(),
      aggregatorOccupation: aggregatorOccupation?.getTitle(),
    }
  })

  return (
    <YandexForm
      accountId={accountId}
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSuccess={formSubmitted}
      isSubmitting={isSubmitting}
      canEdit={canDriverUpdateAggregator}
    />
  )
}
